<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
    </div>
    <div ref="content">
      <el-form label-width="120px" ref="formForceCmplt">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('messages.titForceCmpltType')" prop="forceCmplnTypeCd">
              <div class="input-btn input-btn-table">
                <el-select
                  size="mini"
                  v-model="forceCmplt.forceCmplnTypeCd"
                >
                  <el-option
                    v-for="item in forceCmpltTypeList"
                    :key="item.cd"
                    :label="item.cdHnglNm"
                    :value="item.cd"
                  />
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('messages.titForceCmpltReason')">
              <idc-editor
                ref="editor"
                :editorHtmlContent="forceCmplt.forceCmplnWhy"
                @getEditorContent="getEditorContent"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="dialog-footer align-r">
      <el-button type="info" @click="handleClickCloseForceCmplt">{{
        $t("messages.btnCancel")
      }}</el-button>
      <el-button type="primary" @click="handleClickSaveForceCmplt">{{
        $t("messages.btnSave")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import IdcEditor from "@/components/common/IdcEditor.vue";
export default {
  components: {
    IdcEditor,
  },
  props: {
    exeWflowId: {
      type: String,
      required: true,
    },
    stepCd: {
      type: Number,
      required: true,
    },
    ticktId: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      forceCmpltTypeGrpCd: 3219,
      forceCmpltTypeList: [],
      forceCmplt: {},
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getForceCmpltTypeCd();
    });
  },
  methods: {
    async getForceCmpltTypeCd() {
      const resForceCmpltTypeCd = await this.$BIZ_SERVICE.post(
          this.$API_URLS.Com.getCdList,
          {
            upCd: this.forceCmpltTypeGrpCd,
            useYn: "Y",
          }
        );
      this.forceCmpltTypeList = resForceCmpltTypeCd.data.resData;
    },
    handleClickSaveForceCmplt() {
      var paramObj = Object.assign({
        exeWflowId: this.exeWflowId,
        stepCd: this.stepCd,
        ticktId: this.ticktId,
      }, this.forceCmplt);

      this.$store.dispatch("wflowStore/postForceCmplt", paramObj)
        .then(res => {
          this.handleClickCloseForceCmplt(false);
        });
    },
    handleClickCloseForceCmplt(flag) {
      this.$emit("handleClickCloseForceCmplt", flag);
    },
    getEditorContent(text) {
      this.forceCmplt.forceCmplnWhy = text;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-box {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
